const ConfirmInformation = resolve =>require(['@/page/studentMobile/confirmInformation.vue'], resolve)

// 考试信息确认
export default {
  path: '/studentMobile/home/confirmInformation',
  component: ConfirmInformation
}



// WEBPACK FOOTER //
// ./src/router/studentMobile/confirmInformation.js